export const appConfig = {
  apiBaseUrl: import.meta.env.NEXT_PUBLIC_API_BASE_URL || '/',
  wsURL: import.meta.env.NEXT_PUBLIC_SOCKET_BASE_URL
};

export const QUESTION_RESPONSE_STATUS = {
  ANSWERED: 'answered',
  SKIPPED: 'skipped',
  BOOKMARKED: 'bookmarked',
  NOT_VISITED: 'notVisited',
  VISITED: 'visited'
};

export const REVIEW_STATUS = {
  CORRECT: 'CORRECT',
  PARTIAL: 'PARTIAL',
  INCORRECT: 'INCORRECT',
  SKIPPED: 'SKIPPED'
};

export const questionStatusMap = {};
questionStatusMap[QUESTION_RESPONSE_STATUS.ANSWERED] = {
  color: '#C0E281',
  uiText: 'Answered'
};
questionStatusMap[QUESTION_RESPONSE_STATUS.SKIPPED] = {
  color: '#EED68A',
  uiText: 'Skipped'
};
questionStatusMap[QUESTION_RESPONSE_STATUS.BOOKMARKED] = {
  color: '#EF8888',
  uiText: 'Bookmarked'
};
questionStatusMap[QUESTION_RESPONSE_STATUS.NOT_VISITED] = {
  color: '#0000004D',
  uiText: 'Not Visited'
};

export const reviewStatusMap = {};
reviewStatusMap[REVIEW_STATUS.CORRECT] = {
  color: '#C0E281',
  uiText: 'Correct'
};
reviewStatusMap[REVIEW_STATUS.PARTIAL] = {
  color: '#F3BB51',
  uiText: 'Partial'
};
reviewStatusMap[REVIEW_STATUS.SKIPPED] = {
  color: '#EED68A',
  uiText: 'Skipped'
};
reviewStatusMap[REVIEW_STATUS.INCORRECT] = {
  color: '#EF8888',
  uiText: 'Incorrect'
};

export const USER_ROLES = {
  ADMIN: 'admin',
  STUDENT: 'student',
  TEACHER: 'teacher'
};

export const STUDENTASSIGNMENT_STATUS = {
  YET_TO_START: 'YET_TO_START',
  STARTED: 'STARTED',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED'
};

export const TERMS_OF_USE_URL = 'https://getclasswise.com/terms-of-service';
export const PRIVACY_URL = 'https://getclasswise.com/privacy-policy';
export const PRACTICE_QUESTIONS_URL = '/practice-questions';
export const ASK_ME_QUESTIONS_URL = '/ask-me-questions';
export const LEARN_A_TOPIC_URL = '/learn-a-new-topic';

export const homeMenu = [
  {
    id: 'practice',
    emoji: '⛹️‍♂️',
    title: 'Practice Questions',
    subTitle: 'Challenge yourself with Adaptive Quizzes',
    link: PRACTICE_QUESTIONS_URL,
    bgColor: '#EFF6FF',
    iconBg: '#DBEAFE',
    textColor: '#2563EB'
  },
  {
    id: 'ask',
    emoji: '❓',
    title: 'Ask Questions',
    subTitle: 'Get immediate responses to your queries',
    link: ASK_ME_QUESTIONS_URL,
    bgColor: '#ECFDF5',
    iconBg: '#D1FAE5',
    textColor: '#059669'
  },
  {
    id: 'learn',
    emoji: '🧑‍🏫',
    title: 'Learn a new Topic',
    subTitle: 'Dive into detailed topic explanations',
    link: LEARN_A_TOPIC_URL,
    bgColor: '#F5F3FF',
    iconBg: '#EDE9FE',
    textColor: '#7C3AED'
  }
];

export const practiceTopics = [
  'Chemical Reactions and Equations',
  'Acids, Bases and Salts',
  'Metals and Non-metals',
  'Carbon and its Compounds',
  'Life Processes',
  'Control and Coordination'
];

export const SUBSCRIPTION_PLANS = {
  FREE: 'FREE_STUDENT',
  PRO: 'PRO_STUDENT'
};

export const themeColorHex = '#1A4D8E';

export const API_IDS = {
  SAVE_AND_CONTINUE: 'save-continue-api',
  TIMER_SYNC: 'timer-sync-api'
};

/** Mirrors ASSIGNMENT_ACCESS_DENIAL on the backend — sent as `code` on 403/400 bodies. */
export const ASSIGNMENT_ACCESS_DENIAL = {
  NOT_INVITED: 'NOT_INVITED',
  INSTITUTE_RESTRICTED: 'INSTITUTE_RESTRICTED'
};

export const ASSIGNMENT_END_REASON = {
  TIME_OVER: 'TIME_OVER',
  STUDENT_ENDED: 'STUDENT_ENDED',
  STRICT_MODE_TIME_VIOLATION: 'STRICT_MODE_TIME_VIOLATION',
  STRICT_MODE_TAB_VIOLATION: 'STRICT_MODE_TAB_VIOLATION',
  ALREADY_COMPLETED: 'ALREADY_COMPLETED'
};

export const ASSIGNMENT_END_REASON_UI_TEXT = {
  TIME_OVER: 'Time is up for this assignment. Your assignment has been submitted.',
  STUDENT_ENDED: 'Student ended the assignment.',
  STRICT_MODE_TIME_VIOLATION:
    'The assignment was submitted because you did not return to the assignment within the time limit in strict mode',
  STRICT_MODE_TAB_VIOLATION:
    'The assignment was submitted because tab was switched in strict mode after 3 warnings',
  ALREADY_COMPLETED: 'You have already completed this assignment.'
};

/** Structured copy + tone for the post-results end-reason callout */
export const ASSIGNMENT_END_REASON_UI = {
  TIME_OVER: {
    title: 'Time is up',
    description: 'The timer ran out and your assignment was submitted automatically.',
    tone: 'warning'
  },
  STUDENT_ENDED: {
    title: 'Submitted by you',
    description: 'You ended the assignment and your responses were submitted successfully.',
    tone: 'success'
  },
  STRICT_MODE_TIME_VIOLATION: {
    title: 'Submitted in strict mode',
    description:
      "You didn't return to the assignment within the allowed time, so it was submitted automatically.",
    tone: 'alert'
  },
  STRICT_MODE_TAB_VIOLATION: {
    title: 'Submitted in strict mode',
    description:
      'The assignment was submitted after tab switching exceeded the allowed warnings.',
    tone: 'alert'
  },
  ALREADY_COMPLETED: {
    title: 'Already completed',
    description: "You've already finished this assignment. You can review your results below.",
    tone: 'info'
  }
};

// Copied over from BE statuses
export const RESULT_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR'
};

export const TEXT_TYPE = {
  PLAIN: 'plain',
  TIPTAP: 'tiptap'
};

export const QUESTION_TYPES = {
  MCQ: 'mcq',
  FIB: 'fib',
  SUBJECTIVE: 'subjective',
  CODE: 'code',
  FILE_UPLOAD: 'file-upload',
  AUDIO: 'audio',
  VIDEO: 'video',
  READING_COMPREHENSION: 'reading-comprehension'
};

/**
 * How an X-of-Y rule's alternatives are numbered, from the rule's own `numbering`. Mirrors
 * CHOICE_GROUP_NUMBERING on the server.
 */
export const CHOICE_GROUP_NUMBERING = {
  LETTERED: 'LETTERED',
  CONTINUOUS: 'CONTINUOUS'
};

export const DOCUMENT_UPLOAD_TYPES = ['pdf', 'docx', 'txt', 'jpg', 'jpeg', 'png'];

const BLOCKED_DOCUMENT_UPLOAD_TYPES = new Set(['gif', 'webp']);

export const resolveDocumentUploadTypes = (settingsTypes) => {
  const extra = Array.isArray(settingsTypes)
    ? settingsTypes.map((type) => String(type).replace(/^\./, '').toLowerCase()).filter(Boolean)
    : [];
  return [...new Set([...DOCUMENT_UPLOAD_TYPES, ...extra])].filter(
    (type) => !BLOCKED_DOCUMENT_UPLOAD_TYPES.has(type)
  );
};

export const QUESTION_SOURCES = {
  AI: 'AI',
  CW_LIBRARY: 'CW_LIBRARY',
  TEACHER: 'TEACHER',
  USER_LIBRARY: 'USER_LIBRARY',
  TEMPLATE: 'TEMPLATE'
};
